import { render } from "./UploadDocument.vue?vue&type=template&id=ba7a2e14&scoped=true"
import script from "./UploadDocument.vue?vue&type=script&lang=js"
export * from "./UploadDocument.vue?vue&type=script&lang=js"

import "./UploadDocument.vue?vue&type=style&index=0&id=ba7a2e14&lang=css"
import "./UploadDocument.vue?vue&type=style&index=1&id=ba7a2e14&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba7a2e14"]])

export default __exports__